<template>
  <div class="container">
    <div class="about-us">
      <div class="foot-img"></div>
      <div class="content">
        <el-row style="font-size: 13px; text-align: center">
          <el-col :span="8">
            <el-image style="height: 70px" :src="require('../assets/logo-text.png')">
            </el-image>
          </el-col>
          <el-col :span="16" class="out-url">
            <div v-for="(i, index) in outUrlList" :key="index">
              <p v-for="(v, num) in i.group" :key="num">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="v.url"
                  placement="top-start"
                >
                  <a :href="v.url" target="_blank">{{ v.title }}</a></el-tooltip
                >
              </p>
            </div>
          </el-col>
          <el-col
            :span="24"
            class="out-url"
            style="height: auto; justify-content: center"
          >
            <span v-for="(i, I) in utlList" :key="I">
              <router-link :to="i.url">{{ i.title }}</router-link>
            </span>
          </el-col>
          <el-col :span="24"
            ><p>
              健康游戏忠告:抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防受骗上当。适度济戏益脑，沉法游戏伤身。合理安排时间，享受健康生活。
            </p>
            <span>软著登字第1514161号ISBN978-7-7979-2949-3 新广出审[2016] 4412号</span>
            <br />
            <span>增值电信业务经营许可证 川B2-20100271</span>&nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2022030354号</a>
            <br />
            <span
              >地址：中国（四川）自由贸易试验区成都高新区益州大道中段1800号1栋3层301号</span
            >
            <br />
            <span>电话：17755938251 &nbsp;&nbsp; 邮箱：pengta2024@126.com</span>
          </el-col>
        </el-row>
      </div>
      <div class="foot-img"></div>
    </div>
  </div>
</template>

<script>
const outUrlList = [
  {
    group: [
      {
        title: "茁安子脑超频",
        url: "http://www.droian.cc",
      },
      {
        title: "DIY tDCS",
        url: "",
      },
    ],
  },
  {
    group: [
      {
        title: "穆房产",
        url: "",
      },
      {
        title: "熙雨丽禾",
        url: "",
      },
    ],
  },
  {
    group: [
      {
        title: "八点半测评",
        url: "",
      },
      {
        title: "回回旅游",
        url: "",
      },
    ],
  },
  {
    group: [
      {
        title: "宝多多",
        url: "",
      },
      {
        title: "虚实城",
        url: "",
      },
    ],
  },
  {
    group: [
      {
        title: "新月应相",
        url: "",
      },
      {
        title: "脑超频网店",
        url: "",
      },
    ],
  },
  {
    group: [
      {
        title: "清穆在线",
        url: "",
      },
    ],
  },
];
const utlList = [
  {
    title: "用户协议",
    url: "agreement",
  },
  {
    title: "家长监护工程",
    url: "wardship",
  },
  // {
  //   title: "交易纠纷处理",
  //   url: "",
  // },
  // {
  //   title: "防沉迷系统",
  //   url: "",
  // },
  // {
  //   title: "用户隐私协议",
  //   url: "",
  // },
];
export default {
  data() {
    return {
      outUrlList: outUrlList,
      utlList: utlList,
    };
  },
};
</script>

<style scoped>
.container {
  width: 80%;
  margin: 0 auto;
  background: rgb(20, 22, 24);
  min-width: 1100px;
}
.about-us {
  width: 80%;
  min-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 260px;
  background: rgb(20, 22, 24);
}
.foot-img {
  width: 13%;
  height: 100%;
}
.content {
  width: 84%;
  height: 100%;
}
.el-col {
  height: 70px;
  margin: 10px 0 0 0;
  color: #ffffff;
}
.out-url {
  text-align: left;
  display: flex;
}
a {
  color: #ffffff;
  text-decoration: none;
  margin-right: 10px;
}
a:hover {
  color: #afaeae;
}
.out-url > div > p {
  display: flex;
}
.out-url > div > p > a {
  display: block;
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
